enum ProductReportRecipient {
  ASC = 'ASC',
  Distributor = 'Distributor',
  Insurer = 'Insurer',
  Accounting = 'Accounting',
}
export default ProductReportRecipient;

export type VerifyProductReportRecipient = Utils.VerifyExtends<
  Model.Enum.ProductReportRecipient,
  Utils.ValueOf<typeof ProductReportRecipient>
>;
